import { ClientType } from "../config-api/index.js";
export default ClientType;
//# sourceMappingURL=clientType.js.map